import { Component, computed, inject, input, model, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { BranchService } from '../../../service/branch.service';
import { NotifyService } from '../../../service/notify.service';
import { PanoptycAdminService } from '../../../service/panoptyc-admin.service';
import { Branch } from '../../../types';

@Component({
  selector: 'app-branch-merge-modal',
  templateUrl: './branch-merge-modal.component.html',
  styleUrls: ['./branch-merge-modal.component.scss'],
  standalone: false,
})
export class BranchMergeModalComponent implements OnInit {
  private adminService = inject(PanoptycAdminService);
  private notifyService = inject(NotifyService);
  private branchService = inject(BranchService);
  private router = inject(Router);

  public currentBranch = input.required<Branch>();
  public isVisible = model<boolean>(false);

  public isLoading = signal<boolean>(false);
  public branchChoices = signal<Branch[]>([]);
  public selectedBranch = signal<number | undefined>(undefined);

  public selectedBranchRef = computed(() => this.branchChoices().find((b) => b.id === this.selectedBranch()));

  ngOnInit() {
    this.loadBranches();
  }

  loadBranches() {
    this.isLoading.set(true);

    this.branchService.getBranches().subscribe({
      next: (branches) => {
        this.branchChoices.set(branches.items.filter((b) => b.id !== this.currentBranch().id));
      },
      complete: () => {
        this.isLoading.set(false);
      },
      error: () => {
        this.notifyService.notify('Error loading branches.', 'Close');
      },
    });
  }

  mergeBranch() {
    if (!this.selectedBranch()) return;

    this.notifyService.notify('Currently merging branches. You will be redirected when this is completed.');

    this.adminService.mergeBranch(this.currentBranch().id, this.selectedBranch()).subscribe({
      next: () => {
        this.router.navigate(['/home', 'manage', 'branches']);
      },
      error: () => {
        this.notifyService.notify('Error merging branches.', 'Close');
      },
    });
  }
}
